import {Col, Row, Select} from 'antd';
import {useQuery} from 'react-query';
import api from '../../api';

const MemberSummary = ({
  searchParams = {},
  members = [],
  pageSize,
  pageSizeOptions = [10, 50, 100],
  onPageSizeChange,
}) => {
  const {data: {data: evening_count = []} = {}} = useQuery(['getEveningCount', searchParams, members], () => api.member.memberCount({evening_program: searchParams.evening_program}));
  const {data: {data: special_count = []} = {}} = useQuery(['getSpecialCount', searchParams, members], () => api.member.memberCount({special_program: searchParams.special_program}));
  const {data: {data: accompany_count = []} = {}} = useQuery(['getAccompanyCount', searchParams, members], () => api.member.memberCount({accompany_program: searchParams.accompany_program}));
  const registrations = members.filter((obj) => obj.member_id || obj.can_edit !== false);
  const confirmedRegistrations = registrations.filter((obj) => obj.response_status !== 'declined');
  const participantCount = confirmedRegistrations.length > 0 && confirmedRegistrations.reduce((acc, obj) => {
    const i = obj.partner_last_name ? 2 : 1;
    return acc + i;
  }, 0);

  return <><Row style={{marginBottom: 5}}>
    <Col span={12}>Summe der Anmeldungen: {registrations.length}</Col>
    <Col span={12} style={{textAlign: "right"}}>
      Summe der Teilnehmer:&nbsp;{participantCount || 0}
      {onPageSizeChange && <span style={{marginLeft: 24}}>
        Anzeige:&nbsp;
        <Select
          size="small"
          value={pageSize}
          onChange={onPageSizeChange}
          style={{width: 110}}
        >
          {pageSizeOptions.map((option) => (
            <Select.Option key={option} value={option}>{option} / Seite</Select.Option>
          ))}
        </Select>
      </span>}
    </Col>
  </Row>
  {searchParams.special_program && <Row style={{marginBottom: 20}}>
    <Col span={24} style={{textAlign: "right"}}>Summe der Teilnehmer Fachprogramm: {special_count.count}
      </Col>
  </Row>}
  {searchParams.evening_program && <Row style={{marginBottom: 20}}>
    <Col span={24} style={{textAlign: "right"}}>
      {evening_count.member_count !== undefined ? <>
        Mitglieder beim Get-Together: {evening_count.member_count}<br/>
        Zusätzliche Begleitpersonen: {evening_count.guest_count}<br/>
        Gesamtzahl der Personen beim Get-Together: {evening_count.total_count}
      </> : <>Summe der Teilnehmer Abendprogramm: {evening_count.count}</>}
      </Col>
  </Row>}
  {searchParams.accompany_program && <Row style={{marginBottom: 20}}>
    <Col span={24} style={{textAlign: "right"}}>Summe der Teilnehmer Begleitprogramm: {accompany_count.count}
      </Col>
  </Row>}
  </>
  ;
}

export default MemberSummary;
